import { useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { useTranslation } from '../i18n'
import { useAuth } from '../utils/auth'
import './Header.css'

function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const location = useLocation()
  const navigate = useNavigate()
  const { t } = useTranslation()
  const { user, loading: authLoading } = useAuth()

  const navLinks = [
    { path: '/', label: t('navHome') },
    { path: '/features', label: t('navFeatures') },
    { path: '/how-it-works', label: t('navHowItWorks') },
    { path: '/pricing', label: t('navPricing') },
    { path: '/privacy', label: t('navPrivacy') },
    { path: '/download', label: t('navDownload') },
  ]

  const isActive = (path: string) => location.pathname === path

  const handleAuthClick = () => {
    if (user) {
      navigate('/dashboard')
    } else {
      navigate('/login')
    }
  }

  return (
    <header className="header">
      <div className="container header-container">
        <Link to="/" className="logo">
          <svg className="logo-icon" viewBox="0 0 100 100" width="40" height="40">
            <defs>
              <linearGradient id="logoGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#6366f1" />
                <stop offset="100%" stopColor="#8b5cf6" />
              </linearGradient>
            </defs>
            <circle cx="50" cy="50" r="45" fill="url(#logoGrad)"/>
            <path d="M35 40 L35 60 L55 50 Z" fill="white"/>
            <circle cx="70" cy="35" r="8" fill="#22c55e"/>
            <path d="M66 35 L69 38 L75 32" stroke="white" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          <span className="logo-text">{t('siteTitle')}</span>
        </Link>

        <nav className={`nav ${mobileMenuOpen ? 'nav-open' : ''}`} aria-label="Main navigation">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`nav-link ${isActive(link.path) ? 'nav-link-active' : ''}`}
              onClick={() => setMobileMenuOpen(false)}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        <div className="header-actions">
          {!authLoading && (
            <button onClick={handleAuthClick} className="btn btn-primary">
              {user ? t('navDashboard') : t('navLogin')}
            </button>
          )}
        </div>

        <button
          className="mobile-menu-btn"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
        >
          <span className={`hamburger ${mobileMenuOpen ? 'hamburger-open' : ''}`}></span>
        </button>
      </div>
    </header>
  )
}

export default Header
